import {createContext, Dispatch} from "react";

export interface IPortfolioJob {
  title: string,
  company: string,
  description: string,
  location?: string,
  normalization_choice: string,
  normalization_choice_descriptions: string,
  current_job: boolean,
  start_date: string,
  end_date: string | null,
}

export interface IPortfolioEducation {
  program: string,
  degree_type: string,
  institution_name: string,
  institution_type: string,
  location: string,
  normalization_choice: string,
  graduated: boolean,
  start_date: string
  end_date: string | null,
}


export interface IPortfolioCertificates {
  name?: string;
  certificate_issuer?: string;
  issue_date?: string;
  location?: string;
  certificate_url?: string;
  description?: string;
}

export enum PortfolioStatusTypes {
  'payment_pending'= 'Pending payment',
  'review_pending'= 'Review pending',
  'review_in_progress'= 'Review in progress',
  'review_completed'= 'Review completed',
  'not_created'= 'Not created',
}

export interface IPortfolio {
  id?: string,
  created_at?: string,
  educations?: IPortfolioEducation[],
  jobs?: IPortfolioJob[],
  certificates?: IPortfolioCertificates[],
  portfolio_email?: string,
  portfolio_user_name?: string,
  status?: PortfolioStatusTypes,
  assigned_to_me?: boolean,
  clientSecret?: string,
  banner_text?: string,
  payment_intent_id?: string,
  edit_portfolio?: boolean,
  start_over?: boolean,
  marketplaceUser?: boolean,
  notes?: string,
  resume_available?: boolean,
  date_of_birth?: string
}

export const PortfolioContext = createContext<[IPortfolio, Dispatch<IPortfolio>]>(
  [
    {},
    () => {
    }
  ]
);